import { render, staticRenderFns } from "./BlockLoader.vue?vue&type=template&id=703280fb&scoped=true&"
import script from "./BlockLoader.vue?vue&type=script&lang=js&"
export * from "./BlockLoader.vue?vue&type=script&lang=js&"
import style0 from "./BlockLoader.vue?vue&type=style&index=0&id=703280fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703280fb",
  null
  
)

export default component.exports